// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1E5yT","validationTips":"StatementDescriptor_validationTips__2iAZm"};